import React, { ChangeEvent } from 'react';
import { LinearProgress, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Autocomplete, AutocompleteChangeReason } from '@material-ui/lab';
import { ReactComponent as SearchIcon } from '../../../../assets/images/icon-search.svg';
import { useStyles } from '../styles';
import { OverviewSearchBox } from '../../../../../../components/overview/OverviewSearchBox';
export interface IListSearch<T> {
    placeholder: string;
    onItemSelection?: (object: T | null) => void;
    itemsList?: T[];
    getOptionLabelFunction?: (obj: T) => string;
    renderOptionFunction?: (obj: T) => JSX.Element;
    isAutoComplete?: boolean;
    setSearchText?: (text: string) => void;
    isLoading?: boolean;
}

export function Search<T>({
    onItemSelection,
    isAutoComplete = true,
    itemsList,
    getOptionLabelFunction,
    renderOptionFunction,
    placeholder,
    setSearchText,
    isLoading,
}: IListSearch<T>) {
    const { t } = useTranslation();
    const classes = useStyles();
    function openItem(event: ChangeEvent<{}>, item: T | null, reason: AutocompleteChangeReason) {
        onItemSelection?.(item);
    }
    return (
        <>
            <div className={classes.divider} />
            <div className={classes.searchWrapper}>
                {isAutoComplete && <SearchIcon />}
                <div className={'search'} id="search">
                    {isAutoComplete ? (
                        <Autocomplete
                            noOptionsText={t('misc.noOptions')}
                            getOptionLabel={getOptionLabelFunction}
                            onChange={openItem}
                            renderInput={(params) => (
                                <TextField {...params} placeholder={placeholder} name={'search'} variant="outlined" />
                            )}
                            options={itemsList || []}
                            renderOption={renderOptionFunction}
                            data-component-name={'LIST_ITEMS_SEARCH'}
                        />
                    ) : (
                        <div className={classes.searchRoot}>
                            <OverviewSearchBox onSearch={setSearchText!!} placeholder={placeholder} />
                            {isLoading && <LinearProgress />}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
